// Global feature flags.
// Flip to true to re-enable the Pets feature (routing, dashboard link, onboarding step,
// admin customer detail section). All Pets code remains intact; these flags just gate its
// visibility so the feature can be launched later without a rewrite.
export const FEATURES = {
  pets: false,
};
